import {
  ADD_TO_WISHLIST,
  REMOVE_FROM_WISHLIST,
  CLEAR_WISHLIST,
} from '../actions';

const wishlist_reducer = (state, action) => {
  if (action.type === ADD_TO_WISHLIST) {
    const { product } = action.payload;
    // Check if product already in wishlist
    const exists = state.wishlist.find((item) => item._id === product._id);
    if (exists) {
      return state;
    }
    return {
      ...state,
      wishlist: [...state.wishlist, product],
    };
  }

  if (action.type === REMOVE_FROM_WISHLIST) {
    const { productId } = action.payload;
    return {
      ...state,
      wishlist: state.wishlist.filter((item) => item._id !== productId),
    };
  }

  if (action.type === CLEAR_WISHLIST) {
    return {
      ...state,
      wishlist: [],
    };
  }

  return state;
};

export default wishlist_reducer;
